<template>

    <div class="widget-content-product-list" v-if="category">

        <div class="category-title" v-if="widget.settings.showCategory">
            <dmb-widget-styled-text :style="widget.settings.categoryTextStyle">{{ category.title }}</dmb-widget-styled-text>
        </div>

        <table :style="{ '--dmb-widget-content-product-list-title-factor': titleFactor }">
          <colgroup>
            <col v-if="widget.settings.showImage" class="image-col">
            <col v-if="widget.settings.showTitle" style="width: auto;">
            <col v-if="widget.settings.showPrice"
                 v-for="variant in categoryVariants"
                 :style="{ width: (50 / categoryVariants.length) + '%' }">
          </colgroup>
            <tr v-if="
                widget.settings.showImage || 
                widget.settings.showTitle ||
                (widget.settings.showSubtitle && widget.settings.subtitlePosition === 'NEXT') ||
                (widget.settings.showPrice && widget.settings.showVariant)
            ">
                <th v-if="widget.settings.showImage"></th>
                <th v-if="widget.settings.showTitle"></th>
                <th v-if="widget.settings.showPrice && widget.settings.showVariant" v-for="variant in categoryVariants">
                    <dmb-widget-styled-text :style="widget.settings.variantTextStyle">{{ variant.title }}</dmb-widget-styled-text>
                </th>
            </tr>
            <tr v-for="product in products" :style="{ '--dmb-widget-content-product-list-row-padding': resolvedRowSpacing }">
                <td class="image" v-if="widget.settings.showImage">
                    <div class="product-image" v-if="widget.settings.showImage && getImageAsset(product)" v-background-image="getImageAsset(product).url"></div>
                </td>
                <td class="title" v-if="widget.settings.showTitle">

                    <div class="title-inner">
                        <dmb-widget-styled-text class="title-text" :style="widget.settings.titleTextStyle">{{ product.title }}</dmb-widget-styled-text>
                        <div class="allergy-icons">
                            <dmb-asset v-if="product.glutenfree" :asset-id="showStyle.glutenfreeAssetId" stuffed></dmb-asset>
                            <dmb-asset v-if="product.veggie" :asset-id="showStyle.veggieAssetId" stuffed></dmb-asset>
                        </div>

                      <dmb-widget-styled-text class="subtitleText"
                                              v-if="product.subtitle && widget.settings.showSubtitle && widget.settings.subtitlePosition === 'NEXT'"
                                              :style="widget.settings.subtitleTextStyle">
                        {{ product.subtitle }}
                      </dmb-widget-styled-text>
                    </div>

                    <dmb-widget-styled-text v-if="product.subtitle && widget.settings.showSubtitle && widget.settings.subtitlePosition === 'BELOW'"
                                            :style="widget.settings.subtitleTextStyle">
                        {{ product.subtitle }}
                    </dmb-widget-styled-text>

                </td>
                <td class="price" v-if="widget.settings.showPrice" v-for="variant in categoryVariants">
                    <dmb-widget-styled-text :style="widget.settings.priceTextStyle">
                        <dmb-price :currency="widget.settings.showCurrency" :mode="widget.settings.priceMode" :price="getProductPrice(variant, product)" />
                    </dmb-widget-styled-text>
                </td>
            </tr>
        </table>

    </div>
    <div v-else class="widget-content-placeholder">{{ $t('app.widgets.widgetContentProductList.noProducts') }}</div>

</template>

<script>

import { Vue, Options } from 'vue-class-component'
import { compact, sortBy, isNil } from 'lodash'

import Asset from "../ui/Asset.vue";
import WidgetStyledText from '../WidgetStyledText.vue';
import Price from '../Price.vue';

import ProductState from '../../enum/ProductState';

export default Options({
    name: 'dmb-widget-content-product-list',
    components: {
        [WidgetStyledText.name]: WidgetStyledText,
        [Asset.name]: Asset,
        [Price.name]: Price,
    },
    props: {
        widget: Object,
        freeze: Boolean
    }
})(
    class WidgetContentProductList extends Vue {

        getProductPrice(variant, product){

            return product.prices.find(price => price.variantId === variant.id)?.price;
        }

        get category(){

            return this.$store.getters.getProductCategory(this.widget.settings.categoryId);
        }

        get categoryVariants(){

            return sortBy(this.category.variants, 'sortIndex');
        }

        get products(){
          console.log(this.$store.state.products);
          console.log(this.widget);

            if(this.category == null){
                return [];
            }

            let products = [];

            if(this.widget.settings.productIds?.length){
                products = compact(this.widget.settings.productIds.map(productId => this.$store.getters.getProduct(productId)));
            }
            else if(this.category) {
                 products = this.$store.state.products.products.filter(product => product.categoryId === this.category.id)
            }

            products = products.filter(product => product.state === ProductState.AVAILABLE);

            return sortBy(products, 'sortIndex');
        }

        get resolvedRowSpacing(){

            let spacing = !isNil(this.widget.settings.rowSpacing) ? this.widget.settings.rowSpacing : 10;
            return spacing + 'px';
        }

        get titleFactor(){

           return this.widget.settings.titleTextStyle?.size || 10;
        }

        get showStyle(){

            return this.$store.state.style.showStyle;
        }

        getImageAsset(product){

            return product.imageAssetId ? this.$store.getters.getAsset(product.imageAssetId) : null;
        }
    }
)

</script>
<style src="../../../scss/component/widget/WidgetContentProductList.scss" lang="scss"></style>
